/**
 * This file is auto-generated when using the `populate-svg-icons` Nx target.
 * Do not modify it manually. If you need to add/remove/rename an icon, just modify the files in the
 * `assets/icons/svgs` folder.
 *
 * When this library builds, it will automatically run the generator and this list will be updated.
 *
 * ⚠️ If this file appears in your git changes, please commit it.
 **/

export const svgIconNames = [
    '12p-hide',
    '18p-ai-explain',
    '18p-ai-spark',
    '18p-ai-wand',
    '18p-world',
    'abort',
    'accelerated_execution',
    'account',
    'agile',
    'ai',
    'ai-analyze',
    'ai-check-circle',
    'ai-clear-chat',
    'ai-close-button',
    'ai-explain',
    'ai-explain-small',
    'ai-main',
    'ai-seemore-launcher',
    'ai-summarize',
    'ai-thinking',
    'ai-validate',
    'ai_spark',
    'ai_wand',
    'area-graph',
    'arrow-down',
    'arrow-left-circle',
    'arrow-left-circle-green',
    'arrow-right',
    'asterisk',
    'automated_execution',
    'automatic',
    'automation-readiness',
    'bell',
    'bell--black',
    'beta',
    'broken-link',
    'brushshape',
    'bug',
    'bug-bold',
    'bugInfluence',
    'by-search',
    'charm',
    'check',
    'check-circle',
    'check-list',
    'classify-as-unused',
    'classify-as-used',
    'clock-circle',
    'close-panel',
    'code-box',
    'component',
    'copilot-launcher',
    'copilot-launcher-dark',
    'copilot-launcher-hovered',
    'copy-defect-to-another-project',
    'crosshair',
    'cubes',
    'detach-charm',
    'detach-parameter',
    'development',
    'disabled-detach-charm',
    'drag',
    'edit-pen',
    'empty',
    'empty-star',
    'eraser',
    'excel',
    'excel-black',
    'excel-green',
    'excel-red',
    'exclamation',
    'execution',
    'export-to-excel',
    'external-link-file',
    'first',
    'folder-open',
    'from-file',
    'full-star',
    'generate_page',
    'generic-file',
    'get-script',
    'grid-resize-cursor',
    'helloWorld',
    'honeycomb',
    'icons_custom_click',
    'impact',
    'in-progress',
    'instruction_failed',
    'instruction_passed',
    'instruction_skipped',
    'instruction_warning',
    'jira',
    'last',
    'locota_component',
    'locota_execution',
    'logo',
    'logo-light',
    'manual',
    'md-copy',
    'md-hide',
    'minus',
    'no-data',
    'open-in-new-tab',
    'open-in-new-tab-small',
    'open-panel',
    'open-side-panel',
    'orange-bell',
    'p-lock',
    'paint',
    'paper-clip',
    'parameter',
    'paste-to',
    'pdf',
    'pdf-file',
    'pen-edit-2',
    'pin',
    'plus',
    'plus-circle',
    'plus-circle-green',
    'portfolio',
    'powerpoint',
    'project-assign',
    'project-assign-disable',
    'project-assign-hover',
    'push-script',
    'puzzle',
    'question',
    'quick-test',
    'ready-to-test-no',
    'ready-to-test-yes',
    'record',
    'rectangle-grey',
    'red-bell',
    'remove-me',
    'remove-signture',
    'request_status_empty_state',
    'requirements',
    'rerun_automation',
    'risk',
    'rocket',
    'row-height',
    'row-height-double',
    'row-height-single',
    'row-height-triple',
    'run',
    'run_automation',
    'salesforce_api_component',
    'salesforce_api_execution',
    'script-builder',
    'seemore-cycle',
    'seemore-illustration',
    'seemore-sad-1',
    'seemore-start',
    'seemore-start-2',
    'seemore-working',
    'share-right-arrow',
    'sign',
    'site-map',
    'sitemap',
    'sort-newest-first',
    'sort-oldest-first',
    'specific-users',
    'status-partially-signed',
    'steps',
    'stethoscope',
    'store-script',
    'switch',
    'system',
    'test-set',
    'thumbs-down',
    'thums-up',
    'track-status',
    'tree-bp',
    'tree-selection',
    'tree_accelerated_execution',
    'tree_ai-validate',
    'tree_ai_spark',
    'tree_automated_execution',
    'tree_circle',
    'tree_component',
    'tree_execution',
    'tree_file',
    'tree_film',
    'tree_folder',
    'tree_folder-plus',
    'tree_home',
    'tree_locota_component',
    'tree_locota_execution',
    'tree_random',
    'tree_salesforce_api_component',
    'tree_salesforce_api_execution',
    'tree_video_file',
    'undo',
    'unlink',
    'unlink-user',
    'unsubscribe',
    'user-circle',
    'user-groups',
    'userNotifications_emptyState',
    'view',
    'viewer/Comment',
    'viewer/Disabled',
    'viewer/Not-run',
    'viewer/Passed',
    'viewer/Warning',
    'viewer/ai-spark',
    'viewer/automation',
    'viewer/compare',
    'viewer/compare-disabled',
    'viewer/component',
    'viewer/maximizeWhite',
    'viewer/minimizeWhite',
    'viewer/more',
    'viewer/no-ss',
    'viewer/skip',
    'viewer/switch',
    'viewer/viewer-Failed',
    'wand',
    'wand-disabled',
    'wand-enabled',
    'waterfall',
    'wide-impact',
    'word',
    'world',
    'x',
    'zip-file'
] as const;

export type SvgIconName = typeof svgIconNames[number];
